import { CalculatorPage, ResultPage } from 'src/views/clog/cia'
import pathMap from 'src/paths/pathMap'

class LandedCostRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CALISTA_ADVISORY_LCC,
        component: CalculatorPage
      },
      {
        exact: true,
        path: pathMap.CALISTA_ADVISORY_LCC_RESULT,
        component: ResultPage
      }
    ]
  }
}

export default LandedCostRoute
